import { type PaginationProps, Typography } from "antd"
import React from "react"
import { type TFunction, Trans } from "react-i18next"

import Button from "../Button"

const { Text } = Typography

/**
 * The footer every paginated list shares: a "Showing 1-20 of 25 results" count
 * on the left and labelled Previous / Next controls on the right.
 *
 * `TableComponent` renders it for tables. Lists that are not tables — the
 * document templates tab — reach for these directly so the two cannot drift.
 */

export const paginationShowTotal: PaginationProps["showTotal"] = (
  total,
  range
) => (
  <Text>
    <Trans
      i18nKey="table.showingResults"
      values={{ from: range[0], to: range[1], total }}
      components={{ b: <Text strong /> }}
    />
  </Text>
)

// `hidePager` blanks the numbers as well as the arrows: one page of results has
// nothing to page to, and the count alone says everything the footer can.
export function paginationItemRender(
  t: TFunction,
  hidePager: boolean
): PaginationProps["itemRender"] {
  return function renderItem(_page, type, originalElement) {
    if (hidePager) return null
    if (type === "prev") {
      return (
        <Button className="ant-pagination-item-link1">{t("Previous")}</Button>
      )
    }
    if (type === "next") {
      return <Button className="ant-pagination-item-link1">{t("Next")}</Button>
    }
    return originalElement
  }
}
